import { render, staticRenderFns } from "./single-user-select.vue?vue&type=template&id=81ccad58"
import script from "./single-user-select.vue?vue&type=script&lang=ts"
export * from "./single-user-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports